import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { createCancelablePromise as _createCancelablePromise } from "../service/cancelablePromiseManager";
var CancelablePromiseManager = /*#__PURE__*/function () {
  function CancelablePromiseManager() {
    _classCallCheck(this, CancelablePromiseManager);
    this.promises = new Map();
    this.index = 0;
    this.cleanup = this.cleanup.bind(this);
    this.addCancelablePromise = this.addCancelablePromise.bind(this);
    this.createCancelablePromise = this.createCancelablePromise.bind(this);
  }
  _createClass(CancelablePromiseManager, [{
    key: "cleanup",
    value: function cleanup() {
      this.promises.forEach(function (cancelablePromise) {
        cancelablePromise.cancel();
      });
      this.promises = new Map();
      this.index = 0;
    }
  }, {
    key: "addCancelablePromise",
    value: function addCancelablePromise(promise) {
      var cancelable = this.createCancelablePromise(promise);
      return cancelable.promise;
    }
  }, {
    key: "createCancelablePromise",
    value: function createCancelablePromise(promise) {
      var _this = this;
      var cancelable = _createCancelablePromise(promise);
      var key = this.index;
      this.promises.set(key, cancelable);
      this.index += 1;
      cancelable.promise.then(function () {
        _this.promises["delete"](key);
      })["catch"](function () {
        _this.promises["delete"](key);
      });
      return cancelable;
    }
  }]);
  return CancelablePromiseManager;
}();
export default CancelablePromiseManager;